function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.432 10.524C20.787 7.614 16.4 4.538 12 4.6 7.6 4.537 3.213 7.615.568 10.524a2.211 2.211 0 0 0 0 2.948C3.182 16.351 7.507 19.4 11.839 19.4h.308c4.347 0 8.671-3.049 11.288-5.929a2.21 2.21 0 0 0-.003-2.947zM7.4 12a4.6 4.6 0 1 1 4.6 4.6A4.6 4.6 0 0 1 7.4 12z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 2
});

const SvgView1 = props => /*#__PURE__*/React.createElement(Svg, _extends({
  viewBox: "0 0 24 24"
}, props), _ref, _ref2);

export default SvgView1;